import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import LiveTab from "./pages/LiveTab";
import HistoricalTab from "./pages/HistoricalTab";
import InfoTab from "./pages/InfoTab";
import Login from "./pages/Login";
import CustomizationTab from "./pages/CustomizationTab";
import NotificationsPage from "./pages/NotificationsPage";
import BillReconciliationTab from "./pages/BillReconciliationTab";
import PrivateRoute from "./components/PrivateRoute";

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public route */}
      <Route path="/login" element={<Login />} />

      {/* Redirect root to /live */}
      <Route path="/" element={<Navigate to="/live" replace />} />

      {/* Private routes */}
      <Route
        path="/live"
        element={
          <PrivateRoute>
            <LiveTab />
          </PrivateRoute>
        }
      />
      <Route
        path="/historical"
        element={
          <PrivateRoute>
            <HistoricalTab />
          </PrivateRoute>
        }
      />
      <Route
        path="/info"
        element={
          <PrivateRoute>
            <InfoTab />
          </PrivateRoute>
        }
      />
      <Route
        path="/customization"
        element={
          <PrivateRoute>
            <CustomizationTab />
          </PrivateRoute>
        }
      />
      <Route
        path="/notifications"
        element={
          <PrivateRoute>
            <NotificationsPage />
          </PrivateRoute>
        }
      />
      <Route
        path="/bill-reconciliation"
        element={
          <PrivateRoute>
            <BillReconciliationTab />
          </PrivateRoute>
        }
      />

      {/* Catch all unknown routes and redirect to login */}
      <Route path="*" element={<Login />} />
    </Routes>
  );
};

export default AppRoutes;
